export const getJwtExpiry = (token: string): Date | undefined => {
  const segments = token.split('.');
  const [, payloadSegment] = segments;
  if (segments.length !== 3 || !payloadSegment) return undefined;

  try {
    const payload: unknown = JSON.parse(window.atob(payloadSegment));
    if (typeof payload !== 'object' || payload === null || !('exp' in payload)) return undefined;

    const { exp } = payload as { exp: unknown };
    return typeof exp === 'number' ? new Date(exp * 1000) : undefined;
  } catch {
    return undefined;
  }
};
